<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Motivos para exclusão')"
        centered
        @hidden="cancelar"
        id="modal-excluir-usuario"
    >
        <form @submit.prevent="submit">
            <div class="row">
                <form-radio v-model="motivo" :itens="motivos" />
            </div>

            <div class="row border-top mx-0" v-if="motivo != ''">
                <h3>{{ getTitleMotivo(motivo, motivos) }}</h3>
            </div>
            <div class="row mx-0" v-if="motivo == 1">
                <form-radio
                    class="px-0"
                    v-model="falecimento"
                    :itens="tipos_falecimento"
                />
            </div>
            <div class="row" v-if="falecimento == 'a'">
                <label class="ml-0 col-12">
                    Preencha abaixo as informações da certidão de óbito
                </label>
                <form-calendar
                    :required="true"
                    grid="4"
                    v-model="obito_data_emissao"
                    label="Data de emissão"
                />
                <form-input
                    :required="true"
                    grid="4"
                    v-model="obito_numero_termo"
                    label="Número do termo"
                />
                <form-input
                    :required="true"
                    grid="4"
                    v-model="obito_livro"
                    label="Livro"
                />
                <form-input
                    :required="true"
                    grid="4"
                    v-model="obito_folha"
                    label="Folha"
                />
                <form-select
                    grid="4"
                    v-model="obito_uf"
                    label="Estado"
                    :required="true"
                    @change="changeMunicipios(obito_uf)"
                    :itens="$root.arrays.estados"
                />
                <form-select
                    grid="4"
                    v-model="obito_municipio"
                    label="Município"
                    :required="true"
                    :loading="loadingMunicipios"
                    :itens="municipios"
                />
                <form-input
                    v-model="obito_nome_cartorio"
                    label="Nome do cartório"
                />
            </div>
            <div class="row" v-if="falecimento == 'b' || motivo == 5">
                <label class="ml-0 col-12">Complemento do motivo</label>
                <form-input
                    :required="true"
                    grid="6"
                    v-model="parecer_numero"
                    label="Número do parecer"
                />
                <form-input
                    grid="6"
                    :required="true"
                    v-model="parecer_cpf_servidor"
                    label="CPF do Servidor"
                />
                <form-input
                    v-model="parecer_nome_servidor"
                    :required="true"
                    label="Nome do Servidor"
                />
                <form-calendar
                    grid="4"
                    v-model="parecer_data_emissao"
                    :required="true"
                    label="Data de emissão"
                />
                <form-select
                    grid="4"
                    v-model="parecer_uf"
                    label="Estado"
                    :required="true"
                    @change="changeMunicipios(parecer_uf)"
                    :itens="$root.arrays.estados"
                />
                <form-select
                    grid="4"
                    v-model="parecer_municipio"
                    label="Município"
                    :required="true"
                    :loading="loadingMunicipios"
                    :itens="municipios"
                />
            </div>
            <div
                class="row mx-0"
                v-if="motivo == 2 || motivo == 3 || motivo == 4"
            >
                <form-textarea
                    :required="true"
                    class="px-0"
                    v-model="descricao"
                    label="Complemento do motivo"
                />
            </div>
            <div class="row mt-3" v-if="motivo">
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-success" type="submit">
                        <i class="mdi mdi-check-circle"></i> Concluir
                    </button>
                    <button class="btn btn-danger" @click="cancelar">
                        <i class="mdi mdi-close"></i> Cancelar
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            loading: false,
            motivo: "",
            motivos: [
                { id: 1, value: "Falecimento da pessoa" },
                { id: 2, value: "Desligamento da pessoa daquela família" },
                { id: 3, value: "Solicitação da pessoa" },
                { id: 4, value: "Decisão judicial" },
                { id: 5, value: "Averiguação - Suspeita de Fraude" },
            ],
            falecimento: "",
            tipos_falecimento: [
                { id: "a", value: "Certidão de Óbito" },
                {
                    id: "b",
                    value: "Parecer da gestão municipal do cadastro único",
                },
            ],
            obito_data_emissao: "",
            obito_numero_termo: "",
            obito_livro: "",
            obito_folha: "",
            obito_uf: "",
            obito_municipio: "",
            obito_nome_cartorio: "",
            parecer_numero: "",
            parecer_data_emissao: "",
            parecer_cpf_servidor: "",
            parecer_nome_servidor: "",
            parecer_uf: "",
            parecer_municipio: "",
            descricao: "",
            municipios: [],
            loadingMunicipios: false,
        };
    },
    watch: {
        // motivo() {
        // 	if (this.motivo != 1) {
        // 		this.falecimento = "";
        // 	}

        // },
        motivo() {
            let motivo = this.motivo;
            Object.assign(this.$data, this.$options.data.call(this));
            this.motivo = motivo;
        },
    },
    methods: {
        getTitleMotivo(motivo, motivos) {
            const result = motivos.filter((item) => item.id == motivo);
            return result[0] ? result[0].value : "";
        },
        submit() {
            this.loading = true;
            axios
                .post("api/dashboard/usuario/excluir", {
                    usuario_id: this.item.id,
                    motivo: this.motivo,
                    falecimento: this.falecimento,
                    obito_data_emissao: this.obito_data_emissao,
                    obito_numero_termo: this.obito_numero_termo,
                    obito_livro: this.obito_livro,
                    obito_folha: this.obito_folha,
                    obito_uf: this.obito_uf,
                    obito_municipio: this.obito_municipio,
                    obito_nome_cartorio: this.obito_nome_cartorio,
                    parecer_numero: this.parecer_numero,
                    parecer_data_emissao: this.parecer_data_emissao,
                    parecer_cpf_servidor: this.parecer_cpf_servidor,
                    parecer_nome_servidor: this.parecer_nome_servidor,
                    parecer_uf: this.parecer_uf,
                    parecer_municipio: this.parecer_municipio,
                    descricao: this.descricao,
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: "Usuário excluído com sucesso.",
                    });
                    this.$emit("reload");
                    this.cancelar();
                });
        },
        changeMunicipios(uf) {
            this.loadingMunicipios = true;
            axios
                .get("api/dashboard/enderecos/get/cidades/" + uf)
                .then((response) => {
                    this.municipios = response.data;
                    this.loadingMunicipios = false;
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("modal-excluir-usuario");
        },
    },
};
</script>
